(function () {
    'use strict';

    angular.module("imApp").factory("choicePossRulesRunService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1193,
                    parameters: parms || {}
                });
            },
            listProductChoices: function (parms) {
                return $ihttp.post({
                    method: 1159,
                    parameters: parms || {}
                });
            },
            listModels: function (parms) {
                return $ihttp.post({
                    method: 1174,
                    parameters: parms || {}
                });
            },
            listCounts: function (parms) {
                return $ihttp.post({
                    method: 1194,
                    parameters: parms || {}
                });
            },
            listProducts: function (parms) {
                return $ihttp.post({
                    method: 1195,
                    parameters: parms || {}
                });
            },
            executeOneItem: function (mergeObj) {
                return $ihttp.post({
                    method: 1196,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
